<template>
  <div class="npvContainer">
    <div class="innerContainer">
      <v-card class="cardLeft">
        <span class="headerSpanLeft">Simulations Configuration</span>
        <div style="margin-top: 43px" class="infoContainer">
          <div>
            <v-icon style="color: #4fa2b7"> mdi-label-variant-outline </v-icon>
            <span class="infoLabel">Label</span>
          </div>
          <div>
            <span class="infoValue">{{ simulation[0].smlr_label }}</span>
          </div>
        </div>
        <div class="infoContainer" style="margin-top: 32px">
          <div>
            <v-icon style="color: #4fa2b7"> rule </v-icon>
            <span class="infoLabel">Status</span>
          </div>
          <div>
            <span class="infoValue">{{ simulation[0].smlr_status }}</span>
          </div>
        </div>
        <div class="infoContainer" style="margin-top: 32px">
          <div>
            <v-icon style="color: #4fa2b7"> mdi-account-outline </v-icon>
            <span class="infoLabel">Created by</span>
          </div>
          <div>
            <span class="infoValue">{{ simulation[0].smlr_user_id }}</span>
          </div>
        </div>
        <div class="infoContainer" style="margin-top: 32px">
          <div>
            <v-icon style="color: #4fa2b7"> mdi-calendar-month </v-icon>
            <span class="infoLabel">Created at</span>
          </div>
          <div>
            <span class="infoValue">{{ simulation[0].smlr_created_at }}</span>
          </div>
        </div>
        <div class="infoContainer" style="margin-top: 32px">
          <div>
            <v-icon style="color: #4fa2b7"> mdi-update </v-icon>
            <span class="infoLabel">Updated at</span>
          </div>
          <div>
            <span class="infoValue">{{ simulation[0].smlr_updated_at }}</span>
          </div>
        </div>
        <div class="buttonContainer">
          <span v-if="false" @click="deleteButtonHandler" class="deleteButton">Delete</span>
          <span v-if="false" @click="downloadButtonHandler" class="downloadButton"
            >Download Configuration</span
          >
        </div>
      </v-card>
      <div class="rightContainer">
        <v-card class="cardTabs">
          <div>
            <tabs
              :tabs="tabs"
              :activeTab="activeTab"
              @startTabChange="tabHandler($event)"
            />
          </div>
          <div class="actionsTitleContainer">
            <v-text-field
              v-model="search"
              prepend-inner-icon="search"
              :label="$t('Search')"
              :placeholder="$t('Search')"
              single-line
              class="layer-search"
            />
            <v-btn
              style="margin-left: 16px; margin-right: 8px"
              color="#67A0B4"
              class="actionButtons"
            >
              <v-icon> mdi-refresh </v-icon>
            </v-btn>
            <v-btn
              v-if="false"
              style="margin-right: 8px"
              color="#67A0B4"
              class="actionButtons"
            >
              <v-icon> cloud_upload </v-icon>
            </v-btn>
            <v-btn color="#67A0B4" class="actionButtons" @click="downloadSimulationsReport">
              <v-icon> file_download </v-icon>
            </v-btn>
          </div>
        </v-card>
        <v-tabs-items
          class="itemContainer"
          v-model="activeTab"
          :key="activeTab"
        >
          <v-tab-item :value="0">
            <div class="divDiogo">
              <v-card class="mapCardContainer">
                <div class="mapContainer">
                  <new-map ref="newMap" :key="tableOpen"></new-map>
                </div>
                <div class="radioGroupContainer">
                  <div class="checkBoxContainer">
                    <v-checkbox
                      :key="building.percentage"
                      v-for="(building, index) in report.buildings"
                      :label="building.percentage"
                      @click="percentageSelection(building, index)"
                      :color="colorsArray[index]"
                      on-icon="mdi-radiobox-marked"
                      off-icon="mdi-radiobox-blank"
                    ></v-checkbox>
                  </div>
                  <v-btn
                    style="margin-right: 8px"
                    color="#67A0B4"
                    class="openTableButton"
                    @click="tableOpenHandler"
                    v-if="tableOpen === false"
                  >
                    <v-icon>table_chart</v-icon>
                  </v-btn>
                </div>
              </v-card>
              <v-card v-if="tableOpen === true" class="tablePerc">
                <div class="tableButtonContainer">
                  <v-btn
                    style="margin-right: 8px"
                    color="#67A0B4"
                    class="openTableButton"
                    @click="tableOpenHandler"
                    v-if="tableOpen === true"
                  >
                    <v-icon>table_chart</v-icon>
                  </v-btn>
                </div>
                <div
                  style="
                    position: absolute;
                    width: 100%;
                    overflow: auto;
                    max-height: 78%;
                  "
                >
                  <AtesioTable
                    :rows="report.report.data"
                    :colors="colorsArrayOpacity"
                  ></AtesioTable>
                </div>
              </v-card>
            </div>
          </v-tab-item>
          <v-tab-item :value="1">
            <div class="divDiogo">
              <v-card class="mapCardContainer">
                <div class="tableContainer">
                  <v-data-table
                    :headers="headersBuildings"
                    :items="filteredBuildings"
                    item-key="name"
                    class="buildingsTable"
                  >
                  </v-data-table>
                </div>
                <div class="radioGroupContainer">
                  <div class="checkBoxContainer">
                    <v-checkbox
                      :key="building.percentage"
                      v-for="(building, index) in report.buildings"
                      :label="building.percentage"
                      @click="percentageSelectionBuildings(building, index)"
                      :color="colorsArray[index]"
                      on-icon="mdi-radiobox-marked"
                      off-icon="mdi-radiobox-blank"
                    ></v-checkbox>
                  </div>
                  <v-btn
                    style="margin-right: 8px"
                    color="#67A0B4"
                    class="openTableButton"
                    @click="tableOpenHandler"
                    v-if="tableOpen === false"
                  >
                    <v-icon>table_chart</v-icon>
                  </v-btn>
                </div>
              </v-card>
              <v-card v-if="tableOpen === true" class="tablePerc">
                <div class="tableButtonContainer">
                  <v-btn
                    style="margin-right: 8px"
                    color="#67A0B4"
                    class="openTableButton"
                    @click="tableOpenHandler"
                    v-if="tableOpen === true"
                  >
                    <v-icon>table_chart</v-icon>
                  </v-btn>
                </div>
                <div
                  style="
                    position: absolute;
                    width: 100%;
                    overflow: auto;
                    max-height: 78%;
                  "
                >
                  <AtesioTable
                    :rows="report.report.data"
                    :colors="colorsArrayOpacity"
                  ></AtesioTable>
                </div>
              </v-card>
            </div>
          </v-tab-item>
          <v-tab-item :value="2">
            <div class="divDiogo">
              <v-card class="mapCardContainer">
                <div class="tableContainer">
                  <v-data-table
                    :headers="headersPathways"
                    :items="filteredPathways"
                    item-key="name"
                    class="buildingsTable"
                  >
                  </v-data-table>
                </div>
                <div class="radioGroupContainer">
                  <div class="checkBoxContainer">
                    <v-checkbox
                      :key="building.percentage"
                      v-for="(building, index) in report.buildings"
                      :label="building.percentage"
                      @click="percentageSelectionPathways(building, index)"
                      :color="colorsArray[index]"
                      on-icon="mdi-radiobox-marked"
                      off-icon="mdi-radiobox-blank"
                    ></v-checkbox>
                  </div>
                  <v-btn
                    style="margin-right: 8px"
                    color="#67A0B4"
                    class="openTableButton"
                    @click="tableOpenHandler"
                    v-if="tableOpen === false"
                  >
                    <v-icon>table_chart</v-icon>
                  </v-btn>
                </div>
              </v-card>
              <v-card v-if="tableOpen === true" class="tablePerc">
                <div class="tableButtonContainer">
                  <v-btn
                    style="margin-right: 8px"
                    color="#67A0B4"
                    class="openTableButton"
                    @click="tableOpenHandler"
                    v-if="tableOpen === true"
                  >
                    <v-icon>table_chart</v-icon>
                  </v-btn>
                </div>
                <div
                  style="
                    position: absolute;
                    width: 100%;
                    overflow: auto;
                    max-height: 78%;
                  "
                >
                  <AtesioTable
                    :rows="report.report.data"
                    :colors="colorsArrayOpacity"
                  ></AtesioTable>
                </div>
              </v-card>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import Tabs from "@/components/_Organisms/Tabs";
import Stepper from "@/components/_Organisms/Stepper";
import NewMap from "@/components/NewMap";
import AtesioTable from "./Configuration/components/AtesioTable.vue";

export default {
  name: "NpvConfiguration",

  components: { Tabs, NewMap, Stepper, AtesioTable },

  mixins: [managementDatatableMixin],

  data() {
    return {
      search: "",
      paramsUuid: this.$route.params.uuid,
      dataH: [],
      step: 0,
      colorsArray: ["#EB2321", "#0077B2", "#A2CEE2", "#FFC075", "#9CC5A1"],
      colorsArrayOpacity: [
        "rgba(235, 35, 33, 0.25)",
        "rgba(0, 119, 178, 0.25)",
        "rgba(162, 206, 226, 0.25)",
        "rgba(255, 192, 117, 0.25)",
        "rgba(156, 197, 161, 0.25)",
      ],
      simulation: {},
      report: null,
      radioRow: [],
      ratingNum: [0, 0],
      tableOpen: false,
      headersP: [],
      dataP: [],
      dataT: [],
      buildings: [],
      pathways: [],
      filteredBuildings: [],
      filteredPathways: [],
      selectedPercentagesBuildings: [],
      selectedPercentagesPathways: [],
      tabs: [
        {
          label: "Maps",
        },
        {
          label: "Buildings",
        },
        {
          label: "Pathways",
        },
      ],
      activeTab: 0,
      headersBuildings: [
        { text: "NAME", align: "start", value: "bd_id" },
        { text: "ADDRESS", value: "bd_demand_point_address", align: "start" },
        { text: "PERCENTAGE", value: "percentages", align: "start" },
        { text: "TOTAL HPS", value: "total_hps", align: "start" },
      ],
      headersPathways: [
        { text: "NAME", align: "start", value: "pw_label" },
        { text: "PERCENTAGE", value: "percentage", align: "start" },
        { text: "LENGTH", value: "pw_length", align: "start" },
        { text: "TYPE", value: "pw_type", align: "start" },
        { text: "STATUS", value: "pw_progress", align: "start" },
      ],
    };
  },

  computed: {
    mainHeadersWeb() {
      return this.getHeaders(this.headersT);
    },

    superAdminAndAdminPermission() {
      return (
        (this.isAdmin && this.userHasPermissionTo("update")) ||
        this.isSuperAdmin
      );
    },

    userCanEditOrRemoveItems() {
      return (
        this.isSuperAdmin ||
        this.userHasPermissionTo("update") ||
        this.userHasPermissionTo("destroy")
      );
    },
  },

  mounted() {
    this.getSimulation();
    this.getSimulationReport();
    this.getSimulationBuildings();
    this.getSimulationPathways();
  },

  methods: {
    ...mapActions([
      "GET_SIMULATIONS",
      "GET_SIMULATIONS_UUID",
      "GET_SIMULATIONS_REPORT_UUID",
      "GET_BUILDINGS_UUID",
      "GET_PATHWAYS_UUID",
      "GET_SIMULATIONS_REPORT"
    ]),

    onStepClick(currentStep) {
      this.step = currentStep;
    },

    percentageSelection(building, index) {
      this.updateMapNewObjects(building, this.colorsArray[index]);
    },

    percentageSelectionBuildings(percentage) {
      const selectedPercentage = parseFloat(percentage.percentage);
      const selectedPercentages = [...(this.selectedPercentagesBuildings || [])];
      const existingIndex = selectedPercentages.indexOf(selectedPercentage);
      if (existingIndex !== -1) {
        selectedPercentages.splice(existingIndex, 1);
      } else {
        selectedPercentages.push(selectedPercentage);
      }
      this.selectedPercentagesBuildings = selectedPercentages;
      if (selectedPercentages.length > 0) {
        this.filteredBuildings = this.buildings.filter((building) => {
          const buildingPercentages = building.percentages.split(" | ");
          return buildingPercentages.some((p) =>
            selectedPercentages.includes(parseFloat(p))
          );
        });
      } else {
        this.filteredBuildings = this.buildings;
      }
    },

    percentageSelectionPathways(percentage) {
      const selectedPercentage = parseFloat(percentage.percentage);
      const selectedPercentages = [...(this.selectedPercentagesPathways || [])];
      const existingIndex = selectedPercentages.indexOf(selectedPercentage);
      if (existingIndex !== -1) {
        selectedPercentages.splice(existingIndex, 1);
      } else {
        selectedPercentages.push(selectedPercentage);
      }
      this.selectedPercentagesPathways = selectedPercentages;
      if (selectedPercentages.length > 0) {
        this.filteredPathways = this.pathways.filter((pathway) => {
          const buildingPercentages = pathway.percentage.split(" | ");
          return buildingPercentages.some((p) =>
            selectedPercentages.includes(parseFloat(p))
          );
        });
      } else {
        this.filteredPathways = this.pathways;
      }
    },

    updateMapNewObjects(newObjects, color) {
      this.$refs.newMap.drawNewObject(newObjects, `${color}`);
    },

    tableOpenHandler() {
      this.tableOpen = !this.tableOpen;
    },

    tabHandler(event) {
      this.activeTab = event;
    },

    deleteButtonHandler() {
      console.log("delete");
    },

    downloadButtonHandler() {
      console.log("download");
    },

    async getSimulation() {
      try {
        let resp = await this.GET_SIMULATIONS_UUID(this.paramsUuid);
        this.simulation = resp;
      } catch (error) {
        console.error(error);
      }
    },

    async getSimulationBuildings() {
      try {
        let resp = await this.GET_BUILDINGS_UUID(this.paramsUuid);
        this.buildings = resp.map((building) => ({
          ...building,
          percentages: building.percentages
            .map((percentage, index, array) => {
              return index === array.length - 1
                ? `${percentage}%`
                : `${percentage}% | `;
            })
            .join(""),
        }));
        this.filteredBuildings = this.buildings;
      } catch (error) {
        console.error(error);
      }
    },

    async getSimulationPathways() {
      try {
        let resp = await this.GET_PATHWAYS_UUID(this.paramsUuid);
        this.pathways = resp.map((pathway) => ({
          ...pathway,
          percentage: pathway.percentage
            .map((percentage, index, array) => {
              return index === array.length - 1
                ? `${percentage}%`
                : `${percentage}% | `;
            })
            .join(""),
        }));
        this.filteredPathways = this.pathways;
      } catch (error) {
        console.error(error);
      }
    },
    async downloadSimulationsReport() {
      try{
        const getSimulationReportResult = await this.GET_SIMULATIONS_REPORT(this.paramsUuid);
        window.open(getSimulationReportResult);
      }catch(err){
        this.$toasted.global.toast_error(err.response.data.data)
      }
    },
    async getSimulationReport() {
      try {
        let resp = await this.GET_SIMULATIONS_REPORT_UUID(this.paramsUuid);
        this.report = resp;
        this.report.buildings.sort(
          (a, b) => parseFloat(b.percentage) - parseFloat(a.percentage)
        );
      } catch (error) {
        console.error(error);
      }
    },

    loadingSpinners(id, rows) {
      localStorage.setItem(id, rows);
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },

    getHeaders(mainHeaders) {
      let headers = mainHeaders;
      if (this.userCanEditOrRemoveItems) {
        headers.push({
          text: "",
          value: "action",
          sortable: false,
          width: "19%",
        });
      }
      return headers;
    },

    changeSort(column) {
      if (this.paginationWeb.sortBy === column) {
        this.paginationWeb.descending = !this.paginationWeb.descending;
      } else {
        this.paginationWeb.sortBy = column;
        this.paginationWeb.descending = false;
      }
      if (this.paginationMobile.sortBy === column) {
        this.paginationMobile.descending = !this.paginationMobile.descending;
      } else {
        this.paginationMobile.sortBy = column;
        this.paginationMobile.descending = false;
      }
    },
  },
};
</script>

<style scoped>
.openTableButton {
  height: 30px !important;
  width: 30px !important;
  min-width: auto !important;
  color: #fff;
}

.tableContainer {
  display: flex;
  overflow: auto;
  height: 91.5%;
}

.tableRows {
  min-width: 40px;
  overflow: none;
}
.checkBoxContainer {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.thChildren {
  display: flex;
  flex-shrink: 1;
  min-width: 120px;
}

.tableClass {
  table-layout: auto !important;
}

.topHeader {
  display: flex;
}
.bottomHeader {
  display: flex;
}
.infoContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 23px;
}

.itemContainer {
  height: calc(100% - 63px);
}

.infoValue {
  color: #767676;
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin-left: 27px;
}

.infoLabel {
  color: #767676;
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-left: 5px;
}
.npvContainer {
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: scroll;
  padding-top: 70px;
  padding-left: 40px;
  padding-right: 20px;
  padding-bottom: 60px;
}

.headerSpanLeft {
  color: #67a0b4;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  margin-top: 8px;
  position: absolute;
}

.innerContainer {
  display: flex;
  height: 100%;
  width: 100%;
}

.rightContainer {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  gap: 8px;
}

.cardLeft {
  display: flex;
  flex-direction: column;
  width: 280px;
  height: 100%;
  margin-right: 8px;
  padding: 8px 24px 24px 24px;
  position: relative;
}

.cardTabs {
  display: flex;
  height: 55px;
  padding: 3px 15px 3px 15px;
  align-items: center;
  position: relative;
}

.buttonContainer {
  display: flex;
  justify-content: space-between;
  bottom: 24px;
  right: 24px;
  position: absolute;
}

.deleteButton {
  color: rgba(118, 118, 118, 0.5);
  text-align: center;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin-right: 8px;
  cursor: pointer;
}

.downloadButton {
  color: #767676;
  text-align: center;
  font-family: Lato;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  text-decoration-line: underline;
  cursor: pointer;
}

.layer-search {
  flex: 0 0 auto;
  width: 300px;
  font-size: 12px;
  margin-top: 17px;
}

.actionsTitleContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  right: 8px;
}

.actionButtons {
  width: 30px !important;
  height: 30px !important;
  min-width: auto !important;
  color: #fff;
}

.mapCardContainer {
  flex-shrink: 1;
  min-height: 400px;
  height: 100%;
}

.mapContainer {
  height: 90%;
  margin: 5px;
}

.radioGroupContainer {
  display: flex;
  align-items: center;
  height: calc(10% - 10px);
  margin-left: 10px;
  justify-content: space-between;
}

.tablePerc {
  flex-shrink: 2;
  height: 735px;
}

.divDiogo {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 8px;
}

.tableButtonContainer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 13px;
  margin-bottom: 8px;
}

.v-item-group {
  height: calc(100% - 63px);
}
.v-data-table table {
  border: solid 1px #a1a1a1;
  border-radius: 5px;
}
.v-data-table table thead tr th {
  font-weight: bold;
  font-size: 400;
  padding: 0px 8px;
}

.v-data-table table tbody tr td .v-btn {
  margin-right: 0px !important;
}

.v-data-table .v-data-table-header__sort-badge {
  font-size: 10px;
}

.v-data-table.theme--dark tr th {
  color: #fff !important;
}

.theme--light .v-data-table table thead tr th {
  color: black;
}
.v-data-table table thead tr td {
  color: black;
}

.itemContainer > .v-window__container > .v-window-item.v-window-item--active {
  height: 100%;
}

.itemContainer >>> .v-window__container {
  height: 100%;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #767676 !important;
  font-family: Lato;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 600 !important;
  line-height: 14px;
}
</style>

<style scoped>
.npvContainer >>> .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.npvContainer >>> .theme--light.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th,
.npvContainer >>> .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  background-color: rgba(103, 160, 180, 0.15) !important;
  color: #767676 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Npv/NpvConfiguration.vue